import { NgTemplateOutlet } from '@angular/common'
import { Component, input, output } from '@angular/core'
import { CapitalizeFirstLetterPipe } from '../../pipes'
import { IconComponent } from '../icon'
import { Illustration, IllustrationComponent } from '../illustration'
import { TertiaryButtonComponent } from '../tertiary-button'

export type ErrorStateType = 'full-page' | 'card-medium' | 'card-small' | 'card-tiny'
export interface ErrorStateConfig {
  title: string
  message: string
  actionName: string
}

@Component({
  selector: 'ftr-error-state',
  templateUrl: './error-state.component.html',
  styleUrls: ['./error-state.component.css'],
  imports: [CapitalizeFirstLetterPipe, IconComponent, IllustrationComponent, TertiaryButtonComponent, NgTemplateOutlet],
})
/**
 * A component to display an error with a retry link
 */
export class ErrorStateComponent {
  customConfiguration = input<ErrorStateConfig>()
  entityName = input<string>()
  errorMessage = input<string>()
  type = input<ErrorStateType>('full-page')

  action = output()

  protected readonly illustration = Illustration
}
